import { RecordQualityKey } from '../components/common/CameraRecorder/CameraRecorder';

const STORAGE_KEY = 'cheereval_video_quality';

export const DEFAULT_VIDEO_QUALITY: RecordQualityKey = 'medium_high';

const VALID_QUALITY_KEYS: RecordQualityKey[] = ['medium', 'medium_high', 'high', 'max'];

export function getVideoQuality(): RecordQualityKey {
  const stored = localStorage.getItem(STORAGE_KEY);
  return VALID_QUALITY_KEYS.includes(stored as RecordQualityKey)
    ? (stored as RecordQualityKey)
    : DEFAULT_VIDEO_QUALITY;
}

export function saveVideoQuality(quality: RecordQualityKey): void {
  localStorage.setItem(STORAGE_KEY, quality);
}

export interface VideoQualityOption {
  key: RecordQualityKey;
  label: string;
  description: string;
}

export const VIDEO_QUALITY_OPTIONS: VideoQualityOption[] = [
  { key: 'medium',      label: 'Medium',      description: '2.5 Mbps — smallest file size' },
  { key: 'medium_high', label: 'Medium High',  description: '3.75 Mbps — balanced (default)' },
  { key: 'high',        label: 'High',         description: '5 Mbps — larger files' },
  { key: 'max',         label: 'Max',          description: '8 Mbps — best quality' },
];
